import { LocalStorageService } from "@topline/services/localStorageService";

((module) => {

    module.component('autoSave', {
        template: require('./autoSaveComponent.html'),
        bindings: {
            callback: '&',
            resetTimer: '=',
            delay: '<',
            isEnabled: "<"
        },
        controller: ['$interval', LocalStorageService.componentName, function(this: $TSFixMe, $interval: ng.IIntervalService, localStorageService: LocalStorageService) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $ctrl.secoundUntilCall = parseInt($ctrl.delay);
                var savedValue = localStorageService.getItem('isAutoSaveEnabled');

                $ctrl.isAutoSaveEnabled = savedValue && angular.isDefined(savedValue) ? savedValue.isAutoSaveEnabled : true;

                $ctrl.resetTimer = function () {
                    $ctrl.secoundUntilCall = parseInt($ctrl.delay);
                };

                if ($ctrl.isAutoSaveEnabled && $ctrl.isEnabled) {
                    enableAutoSave();
                }
            };

            $ctrl.$onDestroy = function () {
                disableAutoSave();
            }

            function enableAutoSave() {
                $ctrl.saveAfterSomeTime = $interval(() => execTimeout(), 1000);
            }

            function disableAutoSave() {
                $interval.cancel($ctrl.saveAfterSomeTime);
            }

            $ctrl.isAutoSaveEnabledChanged = () => {
                if (!$ctrl.isAutoSaveEnabled) {
                    disableAutoSave();
                } else {
                    enableAutoSave();
                }
                localStorageService.setItem('isAutoSaveEnabled', { isAutoSaveEnabled: $ctrl.isAutoSaveEnabled });
            };

            function execTimeout() {
                $ctrl.secoundUntilCall = $ctrl.secoundUntilCall - 1;
                if ($ctrl.secoundUntilCall == 0) {
                    $ctrl.callback();
                    $ctrl.secoundUntilCall = parseInt($ctrl.delay);
                }
            }
        }]
    });




})(angular.module('topline.modules'));